const woodyDoorThresholdOptions = [
  'default',
  'nothreshold',
  'woodythreshold10',
  'woodythreshold15',
  'woodythresholdinteriorrebated',
  'woodythresholdinteriorunrebated',
  'woodythresholdsts5x40',
];

export default woodyDoorThresholdOptions;
